module.exports = __webpack_public_path__ + "static/img/start2.07b46fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/start2.png
// module id = YRU5
// module chunks = 1